import { c as _c } from "react/compiler-runtime";
import type { Country } from "@website/ticket-ui/visa/types";
type BoxProperties = {
  title: string;
  detail: string | null;
};
const Box = t0 => {
  const $ = _c(7);
  const {
    title,
    detail
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <div className="text-on-surface-high-emphasis text-subtitle-2 mb-1 whitespace-nowrap">{title}</div>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== detail) {
    t2 = detail && <div className="text-on-surface-medium-emphasis text-caption whitespace-nowrap">{detail}</div>;
    $[2] = detail;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="border-outline-thin elevation-1 flex h-[72px] items-center justify-center gap-x-4 rounded-xl border p-4 text-center md:flex-1"><div>{t1}{t2}</div></div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export type DocumentsProperties = {
  documents: Country["documents"];
};
export const Documents = t0 => {
  const $ = _c(4);
  const {
    documents
  } = t0;
  let t1;
  if ($[0] !== documents) {
    t1 = documents.map(_temp);
    $[0] = documents;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="flex flex-col flex-wrap gap-y-3 pt-3 md:flex-row md:justify-between md:gap-6 md:pt-8">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
function _temp(document) {
  return <Box detail={document.subtitle} key={document.title} title={document.title} />;
}